<template>
  <div id="app">
    <transition name="el-fade-in-linear">
      <div v-if="isShowLoad" class="loading">
          <div class="inner">
              <img src="./assets/image/logo.gif" alt />
          </div>
      </div>
    </transition>
   
    <el-container>
      <el-header class="animate__animated animate__fadeInDown" :class="{dark:!isHome}">
        <div class="header">
          <div class="logo" @click="goHome">
            <img src="./assets/image/logo.gif" alt />
          </div>
          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
            :text-color="header.textColor"
            :active-text-color="header.activeTextColor"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/about">关于我们</el-menu-item>
            <el-menu-item index="/news">新闻动态</el-menu-item>
            <el-menu-item index="/product">产品展示</el-menu-item>
            <el-menu-item index="/knowledge">知识分享</el-menu-item>
            
            
          </el-menu>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <div v-show="isShowFooter">
          <Footer></Footer>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Footer from './components/Footer'
export default {
  name: "App",
  data() {
    return {
      isShowLoad:false,
      router: true,
      isHome:true,
      defaultActive: "/",
      isShowFooter: true,
      header:{
        textColor:"#333",
        activeTextColor:"#0C1F2D"
      }
    };
  },
  components:{
    Footer
  },
  watch:{
    $route(to,from){

      this.handleSelect(to.path); 
      this.defaultActive=to.path;
      window.scrollTo(0,0);
    }
  },
  methods: {
    goHome(){
        this.$router.push({ path: '/' })
    },
    handleSelect(key) {
      this.isShowLoad=true;
      this.isHome = key=="/";
      this.changeHeader(this.isHome);
    },
    changeHeader(type){
      
      setTimeout(() => {
        this.isShowLoad=false;
      }, 1500);

      if(type){
        
        this.header.textColor="#333";
        this.header.activeTextColor="#0C1F2D";
      }else{
        
        this.header.textColor="#aaa";
        this.header.activeTextColor="#fff";
      }

    }
  }
};
</script>

<style lang="scss">
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
* {
  padding: 0;
  margin: 0;
}
// html,
// body {
//   height: 100%;
// }

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
}

.loading{
  position: absolute;
  z-index:20;
  top: 0;
  left:0;
  width:100%;
  height: 100%;
  background-color: rgba(255,255,255,0.9);
  //background: url(./assets/image/bg_black.png);
  .inner{
    height: 100vh;
    width: 100%;
    text-align: center;
    line-height: 100vh;
    img{
        width: 120px;
        //height: 120px;
    }
    
  }
}



.el-header {
  position: fixed;
  z-index: 10;
  width: 100%;
  background: url(./assets/image/bg_white.png);
  .header {
    width: 100%;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin: 0 auto;

    .logo {
      cursor: pointer;
      img {
        height: 60px;
        line-height: 60px;
      }
    }
    .el-menu-demo{
      background-color: transparent;
      border-bottom: none;
      .el-menu-item{
        padding:0 10px;
        &.is-active{
          background-color: #fff;
        }
      }

    }
  }
  &.dark{
    background: none;
    background-color: #000;
    .header{
      .el-menu-demo{
        background-color: transparent;
        border-bottom: none;
        .el-menu-item.is-active{
          background-color:#000;
        }

      }
    }
  }
}
.el-main {
  padding: 0 !important;
}
.el-footer{
   background-color: #f0f0f0;
   box-sizing: border-box;
   padding: 80px 0;
   height: auto !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue